
import Vue from 'vue'
import moment from 'moment'
import { Notification } from '@/domains/global/models'
import { toTitleCase } from '@/domains/global/functions/util'
import { noNavigateNotifications } from './constants'
export default Vue.extend({
  props: {
    notification: { type: Object as () => Notification, required: true }
  },
  computed: {
    icon(): string {
      return 'assignment'
    },
    iconColour(): string {
      return 'tertiary'
    },
    title(): string {
      // TODO - Improve the formatting of notification titles
      const formattedType = toTitleCase(this.notification.type)
      const formattedAction = this.notification.action.split('-').join(' ')
      const formattedTime = moment(this.notification.created).fromNow()

      return `${formattedType} ${formattedAction} (${formattedTime})`
    },
    canNavigate(): boolean {
      const noNavigateActions = noNavigateNotifications[this.notification.type]
      return !noNavigateActions || !noNavigateActions.includes(this.notification.action)
    },
    events(): any {
      if (this.canNavigate) {
        return { click: this.navigateToJob.bind(this) }
      }

      return null
    }
  },
  methods: {
    navigateToJob() {
      this.$router.push(`/jobs/${this.notification.jobId}`)
      this.$emit('close')
    }
  }
})
